/*
start with https://
one or more non \ characters + orangecountyscu.org or .besmartee.com 
no . after
*/
const safeRedirectUrlPattern = /^https:\/\/[^/]+(\.orangecountyscu\.org|\.besmartee\.com)[^.]*$/;

const isValidMortgageRedirectUrl = (url) => {
  return safeRedirectUrlPattern.test(url);
};

export { isValidMortgageRedirectUrl };
